<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<li>
					<pools_checkbox_input v-on:validateField="validateField" v-bind:params="getParams('pools_checkbox')" v-bind:oldValue="oldValue[fieldName]" v-bind:lang="lang" v-bind:templateIndex="templateIndex"></pools_checkbox_input>
				</li>
				<li v-if="noWishes">
					Aucun souhait n'a été sélectionné, veuillez revenir en arrière pour sélectionner des souhaits ou annuler la candidature.
				</li>
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import pools_checkbox_input from '@/components/candidate_forms/pools_checkbox_input.vue';

import lib from '@/libs/main.js';
import ey_spec from '@/libs/ey_spec.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.properties || !scope.properties.fields || !Array.isArray(scope.properties.fields)) return false;
	return scope.properties.fields.every(field => {
		if(!field.params.compulsory) return true;
		return scope.answer[field.params.name];
	});
}
export default {
	name: 'candidate_wishesTpl',
	data() {
		return {
			availableResults : [],
			answer : {},
			oldValue : {},
			isActive : false,
			noWishes : false,
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			}
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		pools_checkbox_input
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			var t = this;
			let out = {};
			this.properties.fields.forEach( field => {
				if(field.params.name == "candidate_wishes" && this.answer[field.params.name]){
					this.answer[field.params.name].forEach(function(k,i){
						t.answer[field.params.name][i] = t.availableResults.choices[k].value;
					});
				}
				if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
			});
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		scrollToThisInput : function(event) {
			return lib.scrollToElem(event.target);
		},
		getParams : function(type){
			var contract;
			switch(this.currentSession.stepsResults.availabilityTpl_1.contractType){
				case "0" : contract = "Césure"; break;
				case "1" : contract = "Césure"; break;
				case "2" : contract = "Alternance"; break;
				case "3" : contract = "TFE"; break;
				case "4" : contract = "CDI"; break;
			}
			var schoolStr = this.currentSession.stepsResults.academic_careerTpl_2.schoolStr;
			var featured = [];
			var choices = [];
			Object.keys(ey_spec[schoolStr]).forEach(function(key){
				if(ey_spec[schoolStr][key][contract] == 'O') choices.push(key);
				if(ey_spec[schoolStr][key][contract] == 'OXXX') featured.push(key);
			});
			var defaultChoices = this.properties && this.properties.fields && this.properties.fields.find(x => x.type == type).params;
			defaultChoices = JSON.parse(JSON.stringify(defaultChoices));
			var list = [];
			let curr_rest = this.currentSession.stepsResults;
			defaultChoices.choices.forEach(function(choice,i){
				if(curr_rest.candidate_wishes0Tpl_4[choice.label] || curr_rest.candidate_wishes1Tpl_5[choice.label] || curr_rest.candidate_wishes2Tpl_6[choice.label]
					|| curr_rest.candidate_wishes3Tpl_7[choice.label] || curr_rest.candidate_wishes4Tpl_8[choice.label]){

					if(featured.indexOf(choice.label) != -1) list.unshift(defaultChoices.choices[i]);
					else if(choices.indexOf(choice.label) != -1) list.push(defaultChoices.choices[i])
				}
			});
			defaultChoices.choices = list;
			this.noWishes = !(list.length);
			// if(!list.length) list.push({"label":"JOK","value":"31","meta":{"_id":"2EKxJGvtttnD62Yxv","value":"JOK"}});
			this.availableResults = defaultChoices;
			return defaultChoices;
		},
		getLabel : componentTools.getLabel
	},
	computed : {
		fieldName : function(index) {
			const params = this.getParams('pools_checkbox');
			return params && params.name;
		},
	},
	watch : {
		templateIndex : {
			handler : function(val, oldval){
				let scope = this;
				let tplRes = scope.currentSession && scope.currentSession.stepsResults && scope.currentSession.stepsResults[scope.$options.name + '_' + scope.templateIndex];
				if(!tplRes){
					scope.oldValue = {};
					scope.answer = {};
				} else {
					scope.oldValue = JSON.parse(JSON.stringify(tplRes));
					scope.answer = JSON.parse(JSON.stringify(tplRes));
				}
			}
		},
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		const curr_rest = this.currentSession.stepsResults;

		if(Object.keys(curr_rest.secteurTpl_3).length === 1){
			const params = this.getParams('pools_checkbox');
			if(!params || !params.choices || !params.choices.length ) return;
			if(this.currentSession.stepsResults.candidate_wishesTpl_9){
				this.currentSession.goToPreviouslPage();
			}else if(params.choices.length < 4) {
				let candidate_wishes = params.choices.map((e,i)=> i)
				this.answer = {candidate_wishes}
				this.validateForm();
			}

		}
		// can't save properly due to _id choice translations
		// if(oldRes) this.oldValue = oldRes.map(e=>e.value);
	}
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ey/candidate_wishes.vue